var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-32 p-8 text-center"},[_c('i',{staticClass:"fas fa-circle-notch fa-spin text-xl"})])
}]

export { render, staticRenderFns }